import { render } from "./CeilingSetup.vue?vue&type=template&id=7cd22e2e"
import script from "./CeilingSetup.vue?vue&type=script&lang=js"
export * from "./CeilingSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__